$(document).ready(function(){
    var $remaining = $('#remaining');
    var $form = null;

    var $row    = $('#form01 tr').has('span.box');
    var $ngIcon = $('<span class="box box-req">必須</span>');
    var $okIcon = $('<span class="box box-ok">OK</span>');

    // ---------- add by spaceclick
    var labels = { 'family_name': 'お名前（姓）',
                   'name': 'お名前（名）',
                   'family_name_kana': 'お名前（ふりがな）（姓）',
                   'name_kana': 'お名前（ふりがな）（名）',
                   'sex': '性別',
                   'year': '生年月日（年）',
                   'month': '生年月日（月）',
                   'day': '生年月日（日）',
                   'age': '年齢',
                   'zip': '郵便番号',
                   'prefectures': '都道府県',
                   'city_area': '市区町村/番地',
                   'city': '市区町村',
                   'street_address': '町名・番地',
                   'building_name': '建物名/号室',
                   'tel': '電話番号',
                   'mail1': 'メールアドレス',
                   'mail2': 'メールアドレス（ドメイン）',
                   'works': 'ご職業',
                   'family': 'ご家族数',
                   'present_home': '現在のお住まい',
                   'room_arrangement': 'ご希望の間取り',
                   'hope_width': 'ご希望の広さ',
                   'budget': 'ご希望の予算',
                   'salary': 'ご年収',
                   'own_fund': '自己資金',
                   'cravia_club': '伊藤忠都市開発・友の会「クレヴィア クラブ」への入会',
                   'crevia_agreement': 'クレヴィア クラブ会員規約への同意',
                   'brillia_agreement': 'Brillia Club会員規約への同意',
                   'asakusa_q1': '事前商談会への参加を',
                   'asakusa_q2': 'オンラインでの接客を希望しますか' };
    // ---------- /add by spaceclick


    function countErrorLength() {
        var length = 0;
        $row.data('valid-flag', true);

        // ---------- add by spaceclick
        $('ul.error-list').empty();
        // ---------- /add by spaceclick

        $.each($form.fields, function(i, $f) {
            var flag = $f.isValid();
            length += ! flag ? 1 : 0;

            var $prRow = $($f.element).closest('tr');
            $prRow.data('valid-flag', $prRow.data('valid-flag') && flag);

            // ---------- add by spaceclick
            if(! flag){
                var tag_id = $($f.element).attr("id")
                $('ul.error-list').append('<li><a href="#' + tag_id + '">' + labels[tag_id] + '</a></li>');
            }
            // ---------- /add by spaceclick

        });

        $remaining.text(length);

        // ---------- add by spaceclick
        if( length === 0 ){
            $(".error").hide();
        }else{
            $('ul.error-list a[href^="#"]').smScroll();
            $(".error").show();
        }
        // ---------- /add by spaceclick

        // ChnageLabel
        $row.each(function() {
            var flag = $(this).data('valid-flag');
            var $replace = null;
            if(flag) {
                $replace = $okIcon.clone();
                $(this).removeClass('ng-row');
                $(this).addClass('ok-row');
            } else {
                $replace = $ngIcon.clone();
                $(this).addClass('ng-row');
                $(this).removeClass('ok-row');
            }

            var $box  = $(this).find('.box.box-req, .box.box-ok');
            $box.each(function() {
                $(this).replaceWith($replace);
            });
        });
    }

    // Custom Validation
    window.Parsley
        .addValidator('noHankaku', {
            requirementType: 'string',
            validateString: function(value) {
                return (value.match(/^[^\x01-\x7E\xA1-\xDF]+$/)) !== null;
            },
            messages: {
                ja: '全角文字で入力してください',
            }
        })
        .addValidator('hiragana', {
            requirementType: 'string',
            validateString: function(value) {
                return (value.match(/^[\u3041-\u3096]+$/)) !== null;
            },
            messages: {
                ja: '全角かな文字で入力してください',
            }
        })
        .addValidator('agreementRequired', {
            requirementType: 'string',
            validateMultiple: function(value, requirement) {
                var $target = $(requirement);
                if(! $target.length) {
                    return true;
                }

                var flag = false;
                $target.each(function() {
                    flag = flag || $(this).prop('checked');
                });

                if(! flag) {
                    return true;
                }

                return value.length > 0;
            }
        });

    $form =
        $("#form01").parsley()
            .on('field:validated', countErrorLength);
    countErrorLength();

    $('#form01 .enrollment-status input[type="radio"]').on('change', function() {
        $('#form01 .term-wrap input[type="checkbox"]').parsley().validate();
    });

    /**
     * For mail domain
     */
    $('.selectable-wrap').each(function() {
        var $input  = $(this).find('input');
        var $target = $(this).find('.selectable-list');

        $.each($form.fields, function(i, $f) {
            $($f.element).on('focus.hide', function() {
                $target.hide();
            });
        });
        $input
            .off('focus.hide')
            .on('focus.show', function(e) {
                e.stopPropagation();
                $target.show();
            })
            .on('click', function(e) {
                e.stopPropagation();
            })
            .on('blur', function() {
                // $target.hide();
            });

        $target.find('li').on('click', function(e) {
            e.preventDefault();
            $input.val($(this).data('value'));
            $($input).parsley().validate();
            $target.hide();
        });
    });
});
